import React, { Component } from "react";

import './Modal.css'

export class Modal extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="modalWindow" onClick={this.handleOutterClick}>
                <div className="modalWindow__content" style={this.props.style || {}} onClick={this.handleInnerClick}>
                    {this.props.content || this.content()}                    
                </div>
            </div>
        );
    }

    content() {
        return (
            <div style={{width: "200px", height: "100px"}}>
                顯示內容
            </div>
        );
    }

    handleOutterClick = (e)=>{
        this.props.onOutterClick && this.props.onOutterClick(e);
    }

    handleInnerClick = (e) => {
        this.props.onInnerClick && this.props.onInnerClick(e);
        e.stopPropagation();//阻止他傳遞到外面導致視窗關掉
    }
}
    